<template>
  <div class="scoreRule">
    <el-container>
      <el-aside
        width="240px"
        style="padding-right:10px;overflow: auto;background: #fff;border-radius: 4px;padding-top:10px;"
      >
        <!-- <el-input v-model="filter" placeholder="请输入参数"></el-input> -->
        <span style="font-size: 16px;color: #455A64;margin-left:12px;">课程标准</span>
        <!-- <el-tree
          :data="treeData"
          :props="defaultProps"
          highlight-current
          :accordion="true"
          :expand-on-click-node="false"
          :filter-node-method="nodeFilter"
          @node-click="handleNodeClick"
          :default-expanded-keys="[1]"
          ref="tree"
        ></el-tree>-->
        <tree ref="mytree" v-on:setId="changeId" value="rule"></tree>
      </el-aside>
      <el-main style="margin-top:-20px;padding-bottom:0px;">
        <!-- <el-card class="box-card">
          <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
            <el-row :gutter="20">
              <el-col :sm="24" :md="12" :lg="6">
                <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
                <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>-->

        <el-card class="box-card" style="margin-top:0px;">
          <!-- <el-row :span="24">
            <el-col :span="12">
              <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
              <el-button type="danger" @click="batchDeleteScoreRule" icon="el-icon-minus">批量删除</el-button>
            </el-col>
            <el-col style="text-align: right" :span="12">
              <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
              <el-button
                style="text-align: right"
                type="primary"
                @click="exportExcel"
                :loading="loading"
                icon="el-icon-upload2"
              >导出</el-button>
            </el-col>
          </el-row>-->
          <el-table
            v-loading="webLoading"
            element-loading-text="数据正在加载中。。。"
            ref="multipleTable"
            :data="page.rows"
            tooltip-effect="dark"
            style="margin-top: 0px; width: 100%;min-height:100px;"
            border
            @selection-change="selectionChange"
          >
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="questionTypeName" label="题型">
              <template slot-scope="scope">
                <span
                  @click="scoreRuleItemById(scope.row)"
                  class="mainColor"
                >{{scope.row.questionTypeName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="数量"></el-table-column>
            <el-table-column prop="score" label="分数"></el-table-column>
            <el-table-column prop="subScore" label="总分"></el-table-column>
            <!-- <el-table-column prop label="操作" width="180" align="center">
              <template slot-scope="scope">
                <div class="operationGroup">
                  <span @click="selection = scope.row.id, editFormVisible = true">编辑</span>
                  <span @click="deleteScoreRule(scope.row)">删除</span>
                </div>
              </template>
            </el-table-column>-->
          </el-table>
          <!-- <el-pagination
            background
            layout="total, prev, pager, next"
            style="margin-top: 20px;text-align: right;"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>-->
        </el-card>
      </el-main>
    </el-container>

    <el-dialog title="添加评分规则" :visible.sync="addFormVisible" width="30%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-form-item label="所属课程" prop="courseId">
          <el-cascader
            clearable
            style="width:100%"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请输入具体课程"
            v-model="addForm.courseId"
            :options="subjectTreeList"
            @change="subjectChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="规则名称" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入规则名称"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>

        <el-form-item label="考试时长" prop="time">
          <el-input
            type="number"
            v-model="addForm.time"
            placeholder="请输入考试时长(分钟)"
            auto-complete="off"
            maxlength="10"
          >
            <el-button slot="append">分钟</el-button>
          </el-input>
        </el-form-item>

        <el-form-item label="分数" prop="score">
          <el-input
            type="number"
            disabled
            v-model="addForm.score"
            placeholder="请输入分数"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="addForm.remark"
            placeholder="请输入备注"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button v-auth="'/scoreRule/addScoreRule'" type="primary" @click="addScoreRule">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑评分规则" :visible.sync="editFormVisible" width="30%" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-form-item label="所属课程" prop="courseId">
          <el-cascader
            clearable
            style="width:100%"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请输入具体课程"
            v-model="editForm.courseId"
            :options="subjectTreeList"
            @change="subjectChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="规则名称" prop="name">
          <el-input
            v-model="editForm.name"
            placeholder="请输入规则名称"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>

        <el-form-item label="考试时长" prop="time">
          <el-input
            type="number"
            v-model="editForm.time"
            placeholder="请输入考试时长(分钟)"
            auto-complete="off"
            maxlength="10"
          >
            <el-button slot="append">分钟</el-button>
          </el-input>
        </el-form-item>

        <el-form-item label="分数" prop="score">
          <el-input
            type="number"
            disabled
            v-model="editForm.score"
            placeholder="请输入分数"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="editForm.remark"
            placeholder="请输入备注"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button v-auth="'/scoreRule/updateScoreRule'" type="primary" @click="updateScoreRule">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加子评分规则" :visible.sync="addFormSonVisible" width="30%" left>
      <el-form
        ref="addFormDSon"
        :model="addFormDSon"
        :label-width="formLabelWidth"
        :rules="addFormDSonRules"
      >
        <el-form-item label="试题题型" prop="questionTypeId">
          <el-select
            style="width:100%"
            clearable
            v-model="addFormDSon.questionTypeId"
            placeholder="请输入试题题型"
          >
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试题数量" prop="count">
          <el-input
            v-model="addFormDSon.count"
            type="number"
            placeholder="请输入试题数量"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>

        <el-form-item label="试题分值" prop="score">
          <el-input
            type="number"
            v-model="addFormDSon.score"
            placeholder="请输入试题分值"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="试题总分">
          <el-input
            type="number"
            disabled
            :value="addFormDSon.score*addFormDSon.count"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            type="number"
            v-model="addFormDSon.sort"
            placeholder="请输入排序"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="addFormDSon.remark"
            placeholder="请输入排序"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormSonVisible = false">取 消</el-button>
        <el-button v-auth="'/scoreRule/addScoreRule'" type="primary" @click="addScoreSonRule">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑子评分规则" :visible.sync="editFormDSonVisible" width="30%" left>
      <el-form
        ref="editFormDSon"
        :model="editFormDSon"
        :label-width="formLabelWidth"
        :rules="addFormDSonRules"
      >
        <el-form-item label="试题题型" prop="questionTypeId">
          <el-select
            style="width:100%"
            clearable
            v-model="editFormDSon.questionTypeId"
            placeholder="请输入试题题型"
          >
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试题数量" prop="count">
          <el-input
            v-model="editFormDSon.count"
            placeholder="请输入试题数量"
            type="number"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>

        <el-form-item label="试题分值" prop="score">
          <el-input
            type="number"
            v-model="editFormDSon.score"
            placeholder="请输入试题分值"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="试题总分">
          <el-input
            type="number"
            disabled
            :value="editFormDSon.score*editFormDSon.count"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            type="number"
            v-model="editFormDSon.sort"
            placeholder="请输入排序"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="editFormDSon.remark"
            placeholder="请输入排序"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormDSonVisible = false">取 消</el-button>
        <el-button v-auth="'/scoreRule/updateScoreRule'" type="primary" @click="updateScoreRuleItem">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="courseId" label="所属课程"></el-table-column>
        <el-table-column prop="score" label="分数"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tree from "../conmom/tree";

export default {
  components: { tree },

  data() {
    return {
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      subjectTreeList: [], //科目，
      typeList: [],

      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      addFormSonVisible: false,
      webLoading: false,
      editFormDSonVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        scoreRuleId: ""
      },
      addForm: {
        courseId: "",
        name: "",
        time: "",
        score: "",
        remark: ""
      },
      addFormDSon: {
        scoreRuleId: "",
        questionTypeId: "",
        count: "",
        score: "",
        remark: "",
        sort: ""
      },
      editFormDSon: {
        scoreRuleId: "",
        questionTypeId: "",
        count: "",
        remark: "",
        score: "",
        sort: ""
      },
      addFormDSonRules: {
        questionTypeId: [
          {
            required: true,
            message: "请输入试题题型",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "试题题型格式不正确"
          }
        ],
        count: [
          {
            required: true,
            message: "请输入试题数量",
            trigger: "blur"
          },
          {
            pattern: /^[1-9]\d*$/,
            message: "试题数量格式不正确"
          }
        ],
        score: [
          {
            pattern: /^[0-9]+([.]{1}[0-9]{1})?$/,
            message: "试题分值格式不正确"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ]
      },
      addFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入所属课程",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属课程格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入规则名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "规则名称长度在1到255个字"
          }
        ],
        time: [
          {
            required: true,
            message: "请输入考试时长(分钟)",
            trigger: "blur"
          },
          {
            pattern: /^[1-9]\d*$/,
            message: "考试时长(分钟)格式不正确"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ]
      },
      editForm: {
        courseId: "",
        name: "",
        time: "",
        score: "",
        remark: ""
      },
      editFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入所属课程",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属课程格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入规则名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "规则名称长度在1到255个字"
          }
        ],
        time: [
          {
            required: true,
            message: "请输入考试时长(分钟)",
            trigger: "blur"
          },
          {
            pattern: /^[1-9]\d*$/,
            message: "考试时长(分钟)格式不正确"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],

      fileAction: `${process.env.BASE_URL}/scoreRule/upload`,
      fileList: [],
      loading: false,
      filter: "",
      treeData: [],
      defaultProps: {
        children: "list",
        label: "name"
      }
    };
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    // 具体课程change事件
    subjectChange(val) {
      if (val.length > 0) {
        this.addForm.courseId = val[val.length - 1];
      } else {
        this.addForm.courseId = "";
      }
    },
    //   获取下拉
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
      // 获取试题类型
      this.api.question
        .questionTypeNormalList()
        .then(result => {
          this.typeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeId(data) {
      console.log(data);
      if (data[1] == 1) {
        this.searchForm.scoreRuleId = data[0].id;
        this.addForm.parentId = data[0].id;
        this.editForm.parentId = data[0].id;
        if (!data[0].disabled) {
          this.pageList();
        }
      } else if (data[1] == 2) {
        this.addFormVisible = true;
        this.addForm.courseId = data[0].id;
      } else if (data[1] == 3) {
        this.addFormSonVisible = true;
        this.searchForm.scoreRuleId = data[0].id;
        this.addFormDSon.scoreRuleId = data[0].id;
      } else if (data[1] == 4) {
        let id = data[0].id;
        this.api.scoreRule
          .getScoreRuleByIdsss({ scoreRuleId: id })
          .then(result => {
            if (result.success) {
              this.editForm = {
                courseId: result.data.courseId,
                name: result.data.name,
                time: result.data.time,
                score: result.data.score,
                id: result.data.id,
                remark: result.data.remark
              };
              this.editFormVisible = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getScoreRule() {
      // this.api.scoreRule
      //   .getScoreRule({
      //     id: this.selection
      //   })
      //   .then(result => {
      //     this.editForm = result.data;
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    },
    pageList() {
      // this.searchForm.pageSize = this.page.pageSize;
      // this.searchForm.pageNumber = this.page.pageNumber;
      // this.searchForm.sortName = this.page.sortName;
      // this.searchForm.sortOrder = this.page.sortOrder;
      this.webLoading = true;
      this.api.scoreRule
        .scoreRuleItemList(this.searchForm)
        .then(result => {
          this.webLoading = false;
          this.page.rows = result.data;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    scoreRuleItemById(row) {
      this.api.scoreRule
        .scoreRuleItemById({ scoreRuleItemId: row.id })
        .then(result => {
          if (result.success) {
            this.editFormDSon = {
              id: result.data.id,
              scoreRuleId: result.data.scoreRuleId,
              questionTypeId: result.data.questionTypeId,
              count: result.data.count,
              score: result.data.score,
              remark: result.data.remark,
              sort: result.data.sort
            };
            this.editFormDSonVisible = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    addScoreRule() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.scoreRule
            .addScoreRule(this.addForm)
            .then(result => {
              if (result.success) {
                this.addFormVisible = false;
                this.$refs.mytree.getSubjectTreeList();
                this.pageList();
                this.$message.success(result.message);
                this.addForm = {
                  courseId: "",
                  name: "",
                  time: "",
                  score: "",
                  remark: ""
                };
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateScoreRuleItem() {
      this.$refs.editFormDSon.validate(valid => {
        if (valid) {
          this.api.scoreRule
            .updateScoreRuleItem(this.editFormDSon)
            .then(result => {
              if (result.success) {
                this.editFormDSonVisible = false;
                this.$message.success(result.message);
                this.pageList();
                this.$refs.mytree.getSubjectTreeList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    addScoreSonRule() {
      this.$refs.addFormDSon.validate(valid => {
        if (valid) {
          this.api.scoreRule
            .addScoreRuleItem(this.addFormDSon)
            .then(result => {
              if (result.success) {
                this.addFormSonVisible = false;
                this.$message.success(result.message);
                this.$refs.mytree.getSubjectTreeList();
                this.pageList();
                this.addFormDSon = {
                  scoreRuleId: "",
                  questionTypeId: "",
                  count: "",
                  score: "",
                  remark: "",
                  sort: ""
                };
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateScoreRule() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.scoreRule
            .updateScoreRule(this.editForm)
            .then(result => {
              if (result.success) {
                this.editFormVisible = false;
                this.$refs.mytree.getSubjectTreeList();
                this.pageList();
                this.$message.success(result.message);
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteScoreRule(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.scoreRule
            .deleteScoreRule([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteScoreRule() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.scoreRule
            .deleteScoreRule(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.scoreRule
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.scoreRule
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getScoreRuleTree() {
      // this.api.scoreRule
      //   .getScoreRuleTree({})
      //   .then(result => {
      //     this.treeData = result.data;
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    },
    nodeFilter(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    treeFilter: function() {
      this.$refs.tree.filter(this.filter);
    },
    handleNodeClick(data) {
      this.searchForm.parentId = data.id;
      this.addForm.parentId = data.id;
      this.editForm.parentId = data.id;
      if (!data.disabled) {
        this.pageList();
      }
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getScoreRule();
      }
    },
    filter: function(newVal) {
      this.treeFilter();
    }
  },
  mounted() {
    this.getScoreRuleTree();
    this.pageList();
    this.getSubjectTreeList();
  }
};
</script>
<style lang="less" scoped>
.scoreRule {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/scoreRule/index_tree.vue